/**
 * Manual-link rejection telemetry (HOF-90 Part 2 / HOF-91).
 *
 * ``handleConnect``'s reject branches are pre-mutation and client-side: a
 * toast, no API call, no row anywhere. So every failed operator drag across
 * the fleet was unobservable, and HOF-90 — an operator who could not link a
 * Lieferschein line to its Gutschrift line — surfaced as a verbal report
 * against a tenant reading 0 ERRORs for 7 days. Without this event there is no
 * way to tell a UI-affordance problem (released on the header instead of the
 * Waren-line dot) from a data problem (the matcher never put the two documents
 * in one group).
 *
 * Lives beside the canvas rather than in ``services/`` because the payload is
 * this screen's classifier vocabulary; only the transport is shared.
 */
import { postTelemetryBeacon } from '../../../services/telemetry';

import type { LineLinkRejection } from './handleConnect';

// Explicit ``/v1`` for the BFF's generic ``/api/v1/{path}`` proxy route, and
// under ``/telemetry/`` so both CSRF middlewares exempt it — sendBeacon
// cannot set ``X-CSRF-Token``. Same two constraints as the page-load URL.
const LINK_REJECT_URL = '/api/v1/telemetry/link-reject';

/**
 * Fire-and-forget POST of one rejected drag. Never throws and never surfaces
 * anything to the operator — she already has the toast, and a telemetry error
 * on top of a failed drag would be strictly worse than losing the row.
 */
export function postLineLinkRejection(rejection: LineLinkRejection): void {
    postTelemetryBeacon(LINK_REJECT_URL, rejection);
}
